module.exports = __webpack_public_path__ + "img/img0207.cf1a8b35.png";